import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/SEOHead";
import { Heart, Award, Users } from "lucide-react";
import puppyImage from "@/assets/puppy-hero.jpg";

const About = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Sobre Nosotros"
        description="Conocé la historia de Gordon Store. Tienda de productos premium para mascotas en Costa Rica, fundada en 2020 con amor por los animales."
        keywords="sobre nosotros, tienda mascotas, Gordon Store, Costa Rica, historia"
      />
      <Header />

      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-pastel-blue/20 via-background to-pastel-peach/20 py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">Sobre Nosotros</h1>
              <p className="text-xl text-muted-foreground">
                Somos una tienda dedicada al bienestar y felicidad de tus mascotas
              </p>
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section className="py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="relative">
                <div className="absolute inset-0 bg-pastel-pink organic-shape opacity-30 -z-10 scale-110" />
                <img
                  src={puppyImage}
                  alt="Cachorro adorable - Gordon Store Costa Rica"
                  loading="lazy"
                  decoding="async"
                  className="w-full h-auto rounded-3xl shadow-card"
                />
              </div>

              <div className="space-y-6">
                <h2 className="text-3xl md:text-4xl font-bold">Nuestra Historia</h2>
                <div className="space-y-4 text-muted-foreground leading-relaxed">
                  <p>
                    Fundada en 2020, Gordon Store nació del amor incondicional por nuestras mascotas y
                    el deseo de ofrecerles lo mejor. Comenzamos como una pequeña tienda familiar y
                    hoy somos un referente en productos de calidad para el cuidado animal.
                  </p>
                  <p>
                    Cada producto que ofrecemos es cuidadosamente seleccionado por nuestro equipo
                    de expertos, garantizando que tu mascota reciba solo lo mejor en nutrición,
                    cuidado y entretenimiento.
                  </p>
                  <p>
                    Creemos que las mascotas son parte de la familia, y merecen ser tratadas con
                    el mismo amor y cuidado que cualquier otro miembro del hogar.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-16 bg-muted">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">Nuestros Valores</h2>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-background rounded-3xl p-8 shadow-soft hover:shadow-card transition-all text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-pastel-pink/30 mb-4">
                  <Heart className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-bold mb-3">Amor por los Animales</h3>
                <p className="text-muted-foreground">
                  Cada decisión que tomamos está guiada por el bienestar y la felicidad de las mascotas
                </p>
              </div>

              <div className="bg-background rounded-3xl p-8 shadow-soft hover:shadow-card transition-all text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-pastel-green/30 mb-4">
                  <Award className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-bold mb-3">Calidad Premium</h3>
                <p className="text-muted-foreground">
                  Solo trabajamos con marcas reconocidas y productos de la más alta calidad
                </p>
              </div>

              <div className="bg-background rounded-3xl p-8 shadow-soft hover:shadow-card transition-all text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent/30 mb-4">
                  <Users className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-bold mb-3">Atención Personalizada</h3>
                <p className="text-muted-foreground">
                  Cada cliente y mascota es único, y nuestro servicio refleja esa individualidad
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto text-center space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold">Nuestra Misión</h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Proporcionar productos y servicios de excelencia que mejoren la calidad de vida de
                las mascotas y fortalezcan el vínculo entre ellas y sus familias. Aspiramos a ser
                el referente de confianza en el cuidado animal, combinando conocimiento experto,
                productos premium y un servicio al cliente excepcional.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default About;
